import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";

import { Link } from "react-router-dom";
import { apiFolderFileLinks, IMAGES_512 } from "../../../utils";

import { useContext } from "react";
import PsContext from "../../../context";

const HeaderLogo = (props) => {
  const context = useContext(PsContext);

  return (
    <div className="section d-none d-md-block py-2">
      <div className="container">
        <Row>
          <Col md={8} className="d-none d-md-block logo-area">
            <Link to="/">
              <img
                src={apiFolderFileLinks(
                  context.settingValue("web_site_top_logo")
                )}
                className="w-100"
              />
            </Link>
          </Col>

          <Col md={4}>
            <div className="row mt-4">
              <div className="col-md-6">
                <button
                  style={{
                    color: context.settingValue("web_site_header_bgcolor"),
                  }}
                  class="btn btn-sm btn-light border w-100"
                >
                  <a
                    href="https://dbcmaram.kalvisalai.in/mob/#/staff/login"
                    target="_blank"
                    className=""
                    style={{
                      color: context.settingValue("web_site_header_bgcolor"),
                      // border: 1px solid context.settingValue("web_site_header_bgcolor"),
                    }}
                  >
                    <i class="fas fa-user-tie"></i> Staff Login
                  </a>
                </button>
              </div>
              <div className="col-md-6">
                <button
                  style={{
                    color: context.settingValue("web_site_header_bgcolor"),
                  }}
                  class="btn btn-sm btn-light border w-100"
                >
                  <a
                    href="https://dbcmaram.kalvisalai.in/mob/#/stu/login"
                    target="_blank"
                    className=""
                    style={{
                      color: context.settingValue("web_site_header_bgcolor"),
                    }}
                  >
                    <i class="fas fa-user"></i> Student login
                  </a>
                </button>
              </div>
            </div>
            <div className="mt-4">
              <ul className="nav justify-content-center top_gray_icons social-icons">
                <li className="nav-item px-2 fs-5">
                  <a
                    href={context.settingValue("web_site_social_youtube")}
                    target="_blank"
                  >
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </li>
                <li className="nav-item px-2 fs-5">
                  <a
                    href={context.settingValue("web_site_social_facebook")}
                    target="_blank"
                  >
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                </li>
                <li className="nav-item px-2 fs-5">
                  <a
                    href={context.settingValue("web_site_social_instagram")}
                    target="_blank"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li className="nav-item px-2 fs-5">
                  <a
                    href={`tel:${context.settingValue(
                      "web_site_enquiry_phone"
                    )}`}
                  >
                    <i className="fa-solid fa-phone me-1"></i>
                    {context.settingValue("web_site_enquiry_phone")}
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HeaderLogo;
